import {connect} from 'react-redux';
import {State} from '../../../types/mx/reducers';
import * as ModalActions from '../../../../wizard/actions/ModalActions';
import {AnyAction, Dispatch} from 'redux';
import * as AttachmentsActions from '../actions/AttachmentsActions';
import {AttachmentFileState, DocumentTypes} from '../types/types';
import SendAttachmentsTargetView from '../components/views/SendAttachmentsTargetView';
import {
    SendAttachmentsToTargetStateProps,
    ModalContainerDispatchProps
} from '../types/containers';
import {CreditoRealSentInfoStatus} from '../../creditoReal/types/mx/types';

const mapStateToProps = (state: State, ownProps): SendAttachmentsToTargetStateProps => {
    const data = ownProps.data || null;
    const documentType: DocumentTypes = !!data ? data.documentType : null;
    const file: AttachmentFileState = !!data ? data.file : null;
    const target: string = !!data ? data.target : null;
    const creditoRealSentInfoStatus: CreditoRealSentInfoStatus = !!data ? data.creditoRealSentInfoStatus : null;
    return {
        documentType,
        file,
        target,
        creditoRealSentInfoStatus
    };
};

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>): ModalContainerDispatchProps => {
    return {
        onPressConfirm: (documentType: DocumentTypes, file: AttachmentFileState, target: string) => () => {
            dispatch(AttachmentsActions
                .SEND_LOAN_ATTACHMENTS_TO_TARGET_ACTION_REQUEST.action(documentType, file, target));
            dispatch(ModalActions.CLOSE_MODAL_ACTION.action());
        },
        onPressClose: () => {
            dispatch(ModalActions.CLOSE_MODAL_ACTION.action());
        }
    };
};

const mergeProps = (stateProps, dispatchProps) => {
    return {
        ...stateProps,
        ...dispatchProps,
        onPressConfirm: dispatchProps.onPressConfirm(stateProps.documentType, stateProps.file, stateProps.target),
    };
};

const SendAttachmentsTargetContainer = connect(
    mapStateToProps, mapDispatchToProps, mergeProps
)(SendAttachmentsTargetView);

export default SendAttachmentsTargetContainer;
